import { render, staticRenderFns } from "./DaysPassed.vue?vue&type=template&id=2127b5ba&"
import script from "./DaysPassed.vue?vue&type=script&lang=js&"
export * from "./DaysPassed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports